'use client';

import { Toaster as Sonner } from 'sonner';

/**
 * Toaster component using sonner library
 *
 * This should be added once at the root layout level to enable toasts throughout the app.
 *
 * @example
 * ```tsx
 * import { Toaster } from '@/components/ui/toaster';
 *
 * export default function RootLayout({ children }) {
 *   return (
 *     <html>
 *       <body>
 *         {children}
 *         <Toaster />
 *       </body>
 *     </html>
 *   );
 * }
 * ```
 *
 * Usage in components:
 * ```tsx
 * import { toast } from 'sonner';
 *
 * toast.success('Story saved successfully');
 * toast.error('Failed to save story');
 * toast.info('Processing your request...');
 * toast.warning('This action cannot be undone');
 * ```
 */
export function Toaster() {
  return (
    <Sonner
      position="top-right"
      offset="16px"
      expand={false}
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: 'bg-card text-foreground border-border shadow-premium rounded-lg font-sans',
          title: 'font-semibold text-foreground',
          description: 'text-muted-foreground text-sm',
          actionButton: 'bg-primary text-primary-foreground hover:bg-primary/90',
          cancelButton: 'bg-muted text-muted-foreground hover:bg-primary/30',
          closeButton: 'bg-card border-border hover:bg-primary/20',
          success: 'bg-card text-foreground border-l-4 border-l-secondary',
          error: 'bg-card text-foreground border-l-4 border-l-destructive',
          warning: 'bg-card text-foreground border-l-4 border-l-accent',
          info: 'bg-card text-foreground border-l-4 border-l-primary',
        },
      }}
    />
  );
}
